import type { ReactNode } from "react";
import {
  CalendarOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import AreaChart from "../AreaChart";
import type { CallChartData, ChartCardKey } from "../../types";
import {
  ChartCard,
  ChartCardHeader,
  ChartHeaderLeft,
  ChartIconCircle,
  ChartSubtitle,
  ChartTitle,
  ChartTitleBlock,
  ChartTotalLabel,
  ChartValue,
  ChartValueRow,
} from "../../style";

const CARD_ICONS: Record<ChartCardKey, ReactNode> = {
  successful: <CheckCircleOutlined />,
  unsuccessful: <CloseCircleOutlined />,
  scheduled_appointments: <CalendarOutlined />,
  rescheduled_appointments: <SwapOutlined />,
  cancelled_appointments: <CloseCircleOutlined />,
  unsuccessful_appointments: <ExclamationCircleOutlined />,
};

interface CallChartCardProps {
  data: CallChartData;
}

export default function CallChartCard({ data }: CallChartCardProps) {
  return (
    <ChartCard>
      <ChartCardHeader align="flex-start" justify="space-between" gap={12}>
        <ChartHeaderLeft align="center" gap={12}>
          <ChartIconCircle align="center" justify="center">
            {CARD_ICONS[data.key]}
          </ChartIconCircle>
          <ChartTitleBlock vertical gap={2}>
            <ChartTitle>{data.title}</ChartTitle>
            <ChartSubtitle>{data.subtitle}</ChartSubtitle>
          </ChartTitleBlock>
        </ChartHeaderLeft>
      </ChartCardHeader>

      <ChartValueRow align="baseline" gap={10}>
        <ChartValue level={3}>{data.total}</ChartValue>
        <ChartTotalLabel>total this period</ChartTotalLabel>
      </ChartValueRow>

      <AreaChart
        data={data.points}
        strokeColor={data.strokeColor}
        fillColor={data.fillColor}
        valueColor={data.valueColor}
        valueLabel={data.valueLabel}
        gradientId={data.gradientId}
        defaultIndex={data.defaultIndex}
      />
    </ChartCard>
  );
}
